import React, { useCallback } from "react";
import { Grid} from "semantic-ui-react";
import { confirmAlert } from "react-confirm-alert";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import InputField from "@commonComponents/formComponents/CustomInputField";
import DeleteIcon from '@commonComponents/deleteIcon'

const ExitInformationForm=({dataSource: {id,exitInfo='',remarks},tableName,isDisabled,onChange,onSelect,onBlur,deleteData,exitInfoList,validateExitInfo})=>{
  const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value}),[tableName,id,onChange])
  const onDropDownChange=(e, {value,name})=>{
    if(validateExitInfo && validateExitInfo(value,id)){
      confirmAlert({
        message: "Only 1 of type AAZ is allowed",
        buttons: [{label: 'OK'}]
      });
       
    }
    else
    onSelect(id,tableName,{[name]:value,id})
  }
  const onBlurHandler=useCallback(({target:{value,name}})=>onBlur(tableName,{[name]:value,id}),[tableName,id,onBlur])
  return (
     <div className="formContainer">
    <Grid.Row>
      <Grid.Column>
      <DropDown
          id={`exitInfo${id}`}
          label="exit information"
          labelClass="text-none"
          name="exitInfo"
          data={exitInfoList}
          value={exitInfo}
         onChange={onDropDownChange}   
         isDisabled={isDisabled}
        />

      </Grid.Column>
      <Grid.Column>
        <InputField
          id={`remarks${id}`}
          type="text"
          label="remarks"
          name="remarks"
          value={remarks}
          clearInput={false}
         isDisabled={isDisabled}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
        />
      </Grid.Column>
      
    </Grid.Row>
    <div className="actionbtns">
    <DeleteIcon isDisabled={isDisabled} onClick={()=>deleteData(id,tableName)} />
    </div>
    </div>
  );
}

export default React.memo(ExitInformationForm)
